module.exports = "../images/homepage/triathlon.jpg";